var App = App || {};

App.BlogFeatureBand = (function ($) {
    "use strict";

    function init() {

        const blogFeatureBand = $(".widget.widget-blog-feature-band");
        if (blogFeatureBand.length) {
            blogFeatureBand.each(function () {
                InitCarousel($(this));

                var nameLinks = $(this).find(".blogpost-name a");
                var chevronLinks = $(this).find("a.indicator-link");

                nameLinks.on("mouseenter focus", function () {
                    $(this).closest(".blogpost-card").find("a.indicator-link").addClass("hover");
                }).on("mouseleave focusout", function () {
                    $(this).closest(".blogpost-card").find("a.indicator-link").removeClass("hover");
                });
                chevronLinks.on("mouseenter focus", function () {
                    $(this).closest(".blogpost-card").find(".blogpost-name a").addClass("hover");
                }).on("mouseleave focusout", function () {
                    $(this).closest(".blogpost-card").find(".blogpost-name a").removeClass("hover");
                });
            });
        }
    }

    function InitCarousel(blogFeatureBand) {
        const carousel = blogFeatureBand.find(".blog-feature-carousel.splide");
        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'slide',
                fixedWidth: "350px",
                gap: "32px",
                drag: true,
                snap: false,
                perMove: 3,
                speed: 750,
                breakpoints: {
                    1399: {
                        perMove: 2,
                        speed: 550,
                    },
                    1199: {
                        perMove: 3,
                        speed: 750,
                        fixedWidth: "294px",
                        gap: "26px",
                    },
                    991: {
                        perMove: 2,
                        speed: 550,
                        fixedWidth: "336px",
                        gap: "18px",
                    },
                    634: {
                        perMove: 1,
                        speed: 400,
                    },
                }
            });

            splideCarousel.on("ready active resized", function () {
                carousel.find(".splide__slide .zag-tooltip-btn").attr("tabindex", -1);

                setTimeout(function () {
                    carousel.find(".splide__slide.is-visible .zag-tooltip-btn").attr("tabindex", 0);
                }, 10);
            });

            splideCarousel.mount();

            const nextBtn = blogFeatureBand.find(".carousel-btn.carousel-next");
            const prevBtn = blogFeatureBand.find(".carousel-btn.carousel-prev");

            splideCarousel.on("move", function () {
                disableButtons(splideCarousel, nextBtn, prevBtn);
            });

            disableButtons(splideCarousel, nextBtn, prevBtn);

            nextBtn.on("click", function () {
                var amount = '+' + splideCarousel.options.perMove;
                splideCarousel.go(amount)
            });

            prevBtn.on("click", function () {
                var amount = '-' + splideCarousel.options.perMove;
                splideCarousel.go(amount)
            });
        }
    }

    function disableButtons(splideCarousel, nextBtn, prevBtn) {
        if (splideCarousel.index + splideCarousel.options.perMove > splideCarousel.length - 1) {
            nextBtn.attr("disabled", true);
        } else {
            nextBtn.attr("disabled", false);
        }
        if (splideCarousel.index - splideCarousel.options.perMove < 0) {
            prevBtn.attr("disabled", true);
        } else {
            prevBtn.attr("disabled", false);

        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlogFeatureBand.init();
});